<template>
  <div v-if="!dataIsNull">
    <b-jumbotron
      :header="'v. '+processInfo.header"
      :lead="'Init. Date: ' + processInfo.init_date + ' | Last Update: ' + processInfo.last_update"
      id="last-version-jumbo"
    >
      <b-button variant="primary" @click="initializeFlowChart">Flowchart Map Tree</b-button>
    </b-jumbotron>
    <div id="taskTreeBox" :class="taskTreeToggle ? 'tree-show' : ''">
      <template>
        <vue-mermaid :nodes="dataTree" type="graph TD" @nodeClick="editNode('teste')"></vue-mermaid>
      </template>
    </div>

    <!-- Table Grid -->
    <b-table
      selectable
      select-mode="single"
      selectedVariant="secondary"
      hover
      show-empty
      :items="objItems"
      :fields="!viewFind?objFilds:objFildsFind"
      @row-clicked="gridSelected"
    >
      <!-- TEMPLATE EMPTY -->
      <template slot="empty">
        <p>Nenhum registro encontrado</p>
      </template>

      <!-- TEMPLATE NUM-RECORD -->
      <template
        slot="num-record"
        slot-scope="data"
      >{{ data.index + 1 * ((numPage * rowLimit) - rowLimit) + 1 }}</template>

      <!-- TEMPLATE ACTION -->
      <template v-slot:cell(actions)="row" v-if="!viewFind">
        <b-button
          size="sm"
          pill
          variant="outline-secondary"
          :disabled="checkRelease()"
          @click="rowSelected(row.item)"
        >
          <i class="fas fa-pen"></i>
        </b-button>
      </template>
    </b-table>

    <!-- PAGINATION -->
    <b-pagination
      size="sm"
      pills
      v-model="numPage"
      :total-rows="rowCount"
      :per-page="rowLimit"
      align="center"
      class="btn-default"
    />
  </div>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - PAGE */
export default {
  name: "BpmProcessTaskGrid",
  comonents: {},
  computed: {
    viewFind() {
      return this.$store.state.layout.viewFind;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objFilter() {
      return this.$store.state.objFilter;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    objProcess() {
      return this.$store.state.objProcess;
    },
    applyFilter() {
      return this.$store.state.applyFilter;
    },
    resetFilter() {
      return this.$store.state.resetFilter;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      dataTree: [],
      processInfo: {
        header: "",
        init_date: "",
        last_update: ""
      },
      taskTree: {
        data: {},
        taskList: {},
        taskDetail: {}
      },
      taskTreeToggle: false,

      /* Controls */
      urlServices: "chameleon-ds/api/internal/bpm-task",
      primary_key: "bpm_task_id",
      numPage: 1,
      rowLimit: 0,
      rowCount: 0,
      dataIsNull: true,

      /* Objects Page */
      nameObjData: "bpm_task_data",
      objItems: [],
      objFilds: [
        { key: "num-record", label: "", class: "cell-num-record" },
        { key: "actions", label: "", class: "cell-action" },
        {
          key: "bpm_task_id",
          label: "Task Id",
          sortable: true
        },
        {
          key: "bpm_task_data.task_name",
          label: "Task Name",
          sortable: true
        },
        {
          key: "bpm_task_data.open_function_name",
          label: "Open Function Name",
          sortable: true
        }
      ],
      objFildsFind: [
        { key: "num-record", label: "", class: "cell-num-record" },
        { key: "actions", label: "", class: "cell-action" },
        {
          key: "bpm_task_data.task_name",
          label: "Process Name",
          sortable: true
        },
        { key: "access_key", label: "Access Key", sortable: true }
      ]
    };
  },

  /* METHODS */
  methods: {
    init() {
      this.list();
    },
    list() {
      this.$store.commit("setShowLoading", true);
      this.processInfoCheck();
      this.objItems = [];
      let paramFilter = {};

      let id = this.objProcess.version_data
        ? this.objProcess.version_data.bpm_process_version_id
        : this.objProcess.bpm_process_version_id;

      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objFilter).length > 0) {
          paramFilter = { ...this.objFilter };
        }

        if (Object.entries(paramFilter).length === 0) {
          const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-bpm-process-version-id`;
          paramFilter = {
            bpm_process_version_id: id
          };

          axios.post(url, paramFilter).then(res => {
            if (res.data[0][`${this.primary_key}`] != null)
              this.objItems = res.data;
            this.$store.commit("setShowLoading", false);
          });
        } else {
          const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-filter`;
          axios.post(url, paramFilter).then(res => {
            if (res.data[0][`${this.primary_key}`] != null)
              this.objItems = res.data;
            this.$store.commit("setObjFilter", {});
            this.$store.commit("setShowLoading", false);
          });
        }
      }
    },
    rowSelected(item) {
      this.$emit("selectedBpmProcessTask", item);
    },
    gridSelected(items) {
      if (this.viewFind === false && items) {
        this.$store.commit("setObjSelected", items);
      }
    },
    processInfoCheck() {
      /* Supress undefined obj error */
      if (this.objProcess) {
        let objTemp = this.objProcess.version_data
          ? this.objProcess.version_data
          : this.objProcess;

        if (objTemp) {
          let process = objTemp.bpm_process_version_data;

          if (process) {
            this.processInfo.header = process.version_number
              ? process.version_number
              : "";
            this.processInfo.init_date = process.init_dt ? process.init_dt : "";
            this.processInfo.last_update = objTemp.last_update_dt
              ? objTemp.last_update_dt
              : "";
          }
        }
      }
    },
    checkRelease() {
      if (this.objProcess) {
        if (
          this.objProcess.process_data.bpm_process_data.end_dt ||
          this.objProcess.version_data.bpm_process_version_data.end_dt
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    initializeFlowChart() {
      this.taskTreeToggle = !this.taskTreeToggle;
      if (this.taskTreeToggle) {
        this.dataTree = [];
        /**
         * Monta a lista de items, isso precisa ser carregado antes
         * para que o preenchiemento do campo "next" aconteça da forma correta
         */
        for (let i = 0; i < this.objItems.length; i++) {
          const element = this.objItems[i];
          this.dataTree.push({
            id: element.bpm_task_id,
            text: element.bpm_task_data.task_label,
            next: []
          });
        }
        /* Percorre a lista recem criada para verificar se a mesmase ligará a algum item (next) */
        for (let i = 0; i < this.dataTree.length; i++) {
          const dataTreeID = this.dataTree[i].id;
          /**
           * Percorre novamente a lista de itens para carregar (for dentro de for)
           * a lista de predecessores e já alimentar dataTree.next com esses valores
           */
          for (let j = 0; j < this.objItems.length; j++) {
            /* Primeiro, é verificado se o campo predecessor não está vazio */
            if (this.objItems[j].bpm_task_data.task_id_predecessors) {
              /* Confirma se não é um array e se é necessário converter */
              let arrayPredecessors = [];
              if (
                !Array.isArray(
                  this.objItems[j].bpm_task_data.task_id_predecessors
                )
              ) {
                arrayPredecessors = this.objItems[
                  j
                ].bpm_task_data.task_id_predecessors.split(",");
              } else {
                arrayPredecessors = this.objItems[j].bpm_task_data
                  .task_id_predecessors;
              }
              /* Percorre os predecessores comparando o id do dataTree com o ID do predecessor */
              for (let k = 0; k < arrayPredecessors.length; k++) {
                /**
                 * dataTreeID = id do dataTree
                 * arrayPredecessors[k] = id do predecessor (deve ser igual ao dataTreeID)
                 * this.dataTree[i] = predecessor que será ligado a this.objItems[j].bpm_task_id
                 * this.objItems[j].bpm_task_id é o item que possui o ID do predecessor
                 */
                if (dataTreeID == arrayPredecessors[k]) {
                  this.dataTree[i].next.push(this.objItems[j].bpm_task_id);
                }
              }
            }
          }
        }
      }
    },
    getDataIsNull() {
      if (this.objProcess) {
        if (this.objProcess.version_data) {
          this.dataIsNull = false;
        } else {
          this.dataIsNull = true;
        }
      } else {
        this.dataIsNull = true;
      }
    }
  },

  /* WATCH */
  watch: {
    applyFilter() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.applyFilter === true) {
          this.list();
        }
      }
    },
    resetFilter() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.resetFilter === true) {
          this.list();
        }
      }
    },
    urlServicesStore() {
      if (this.urlServicesStore === this.urlServices) {
        this.$store.commit("setObjFilter", {});
        this.list();
      }
    },
    objProcess() {
      this.processInfoCheck();
      this.getDataIsNull();
    }
  },

  /* LIFE CICLE */
  mounted() {
    if (this.objProcess)
      if (this.objProcess.version_data) {
        this.init();
        this.getDataIsNull();
      }
  }
};
</script>